"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { observable, action, computed } from "mobx";
import { MenuItem } from "../../../pieces/MenuItem/MenuItem";
import * as styles from "./FolderComponent-css";
import { handleMouseUpByBlurring } from "../../../../utils";
export let FolderComponent = class extends React.Component {
  constructor(props) {
    super(props);
    this.dragHoverCounter = 0;
  }
  handleClick() {
    const { onClick, disableSelect } = this.props;
    if (disableSelect) return;
    onClick?.();
  }
  render() {
    const { name, icon, selected, overrideNameComponent, disableSelect, disableDrop, ...props } = this.props;
    const handleClick = this.handleClick.bind(this);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.container({ draggedOver: !disableDrop && this.isDragHovering }),
        onDrop: this.dropHandler,
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDragOver: (event) => {
          event.preventDefault();
        }
      },
      /* @__PURE__ */ React.createElement(
        MenuItem,
        {
          strong: true,
          truncate: true,
          startElement: icon,
          active: selected,
          disabled: disableSelect || disableDrop,
          ...props,
          onClick: handleClick,
          onMouseUp: handleMouseUpByBlurring
        },
        !!overrideNameComponent ? overrideNameComponent : name
      )
    );
  }
  get isDragHovering() {
    return this.dragHoverCounter > 0;
  }
  onDragEnter(event) {
    event.preventDefault();
    ++this.dragHoverCounter;
  }
  onDragLeave(event) {
    event.preventDefault();
    --this.dragHoverCounter;
  }
  dropHandler(event) {
    event.preventDefault();
    this.dragHoverCounter = 0;
    const { onDrop, disableDrop } = this.props;
    if (!!onDrop && !disableDrop) {
      onDrop(event);
    }
  }
};
FolderComponent.defaultProps = {
  element: "button",
  hasMenuOption: false,
  disableSelect: false,
  disableDrop: false
};
__decorateClass([
  observable.ref
], FolderComponent.prototype, "dragHoverCounter", 2);
__decorateClass([
  computed
], FolderComponent.prototype, "isDragHovering", 1);
__decorateClass([
  action.bound
], FolderComponent.prototype, "onDragEnter", 1);
__decorateClass([
  action.bound
], FolderComponent.prototype, "onDragLeave", 1);
__decorateClass([
  action.bound
], FolderComponent.prototype, "dropHandler", 1);
FolderComponent = __decorateClass([
  observer
], FolderComponent);
